import React from 'react'

const Login = () => {
  return (
    <div className='login-container'>

    </div>
  )
}

export default Login